goog.provide('el8.appchart.visitNote.vitalFields');

goog.require('el8.util.consts');

/**
 * This module defines the form fields used when working with vitals,
 * so the form can be re-used by the VisitNote and Document Vitals dialog
 */
el8.appchart.visitNote.vitalFields = (function() {

    var fieldMap = {
        bp_0: getBpFields(0),

        hr: [{
                name: 'hr',
                selector: ':input[name="hr"]',
                infoText: 'HR',
                maxLength: 3 
            }, {
                name: 'hrNote',
                property: 'extraNote',
                selector: ":input[name='hrNote']",
                infoText: 'note...',
                maxLength: 250,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                doShrink: true,
                sectionSelector: '.hr-note-section',
                sectionTrigger: '.vitals-note-show-trigger[data-type="hr"]',
                sectionWrapClass: '.vitals-wrapper'
            }
        ],

        rr: [{
                name: 'rr',
                selector: ":input[name='rr']",
                infoText: 'RR',
                maxLength: 2
            }, {
                name: 'rrNote',
                property: 'extraNote',
                selector: ":input[name='rrNote']",
                infoText: 'note...',
                maxLength: 250,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                doShrink: true,
                sectionSelector: '.rr-note-section',
                sectionTrigger: '.vitals-note-show-trigger[data-type="rr"]',
                sectionWrapClass: '.vitals-wrapper'
            }
        ],

        temperature: [{
                name: 'temperature',
                selector: ":input[name='temperature']",
                infoText: '°F',
                maxLength: 5
            }, {
                name: 'tempNote',
                property: 'extraNote',
                selector: ":input[name='tempNote']",
                infoText: 'note...',
                maxLength: 250,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                doShrink: true,
                sectionSelector: '.temp-note-section',
                sectionTrigger: '.vitals-note-show-trigger[data-type="temp"]',
                sectionWrapClass: '.vitals-wrapper'
            }
        ],

        weight: [{
                name: 'weight',
                selector: ":input[name='weight']",
                infoText: 'lbs',
                maxLength: 8
            }, {
                name: 'wtNote',
                property: 'extraNote',
                selector: ":input[name='wtNote']",
                infoText: 'note...',
                maxLength: 150,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                doShrink: true,
                sectionSelector: '.wt-note-section',
                sectionTrigger: '.vitals-note-show-trigger[data-type="wt"]',
                sectionWrapClass: '.vitals-wrapper'
            }
        ],

        height: [{
                name: 'height',
                selector: ":input[name='height']",
                infoText: 'inches',
                maxLength: 8
            }, {
                name: 'htNote',
                property: 'extraNote',
                selector: ":input[name='htNote']",
                infoText: 'note...',
                maxLength: 150,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                doShrink: true,
                sectionSelector: '.ht-note-section',
                sectionTrigger: '.vitals-note-show-trigger[data-type="ht"]',
                sectionWrapClass: '.vitals-wrapper'
            }
        ],

        oxygen: [{
                name: 'percent',
                selector: ":input[name='oxygen']",
                infoText: 'O2',
                maxLength: 3
            }, {
                name: 'oxygenNote',
                property: 'extraNote',
                selector: ":input[name='oxygenNote']",
                infoText: 'note...',
                maxLength: 150,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                doShrink: true,
                sectionSelector: '.oxygen-note-section',
                sectionTrigger: '.vitals-note-show-trigger[data-type="oxygen"]',
                sectionWrapClass: '.vitals-wrapper'
            }
        ],

        hc: [{
                name: 'hc',
                selector: ":input[name='hc']",
                infoText: 'cms',
                maxLength: 8
            }, {
                name: 'hcNote',
                property: 'extraNote',
                selector: ":input[name='hcNote']",
                infoText: 'note...',
                maxLength: 150,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                doShrink: true,
                sectionSelector: '.hc-note-section',
                sectionTrigger: '.vitals-note-show-trigger[data-type="hc"]',
                sectionWrapClass: '.vitals-wrapper'
            }
        ],
        pain: [{
                name: 'pain',
                selector: ":input[name='pain']",
                infoText: '0-10',
                maxLength: 2
            }, {
                name: 'painNote',
                property: 'extraNote',
                selector: ":input[name='painNote']",
                infoText: 'note...',
                maxLength: 150,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                doShrink: true,
                sectionSelector: '.pain-note-section',
                sectionTrigger: '.vitals-note-show-trigger[data-type="pain"]',
                sectionWrapClass: '.vitals-wrapper'
            }
        ]

    };

    var customFieldMap = {};

    return {

        // Needs to be inited after el8.data.practiceSettings data load
        initCustomFieldMap: function() {
            if (el8.data.practiceSettings.isAdditionalVitalsEnabled()) {
                 el8.util.consts.ADDITIONAL_VITALS.forEach(function(customVital) {
                     customFieldMap[customVital] = [{
                             name: customVital,
                             property: 'value',
                             selector: ":input[name='"+customVital+"']",
                             infoText: '...',
                             maxLength: 8
                         }, {
                             name: customVital+'Note',
                             property: 'extraNote',
                             selector: ":input[name='"+customVital+"Note']",
                             infoText: 'note...',
                             maxLength: 150,
                             height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                             doShrink: true,
                             sectionSelector: '.'+customVital+'-note-section',
                             sectionTrigger: '.vitals-note-show-trigger[data-type="'+customVital+'"]',
                             sectionWrapClass: '.vitals-wrapper'
                         }
                     ];
                 });
            }

        },

        /**
         * The visit note wants the field specs for each vital separately
         */
        getFieldForVital: function(vitalName) {
            return fieldMap[vitalName] || customFieldMap[vitalName];
        },

        /**
         * And the dialog doesn't
         */
        getAll: function(includeCustomObservations) {
            var allFields = [];
            for (var key in fieldMap) {
                if (fieldMap.hasOwnProperty(key)) {
                    allFields = allFields.concat(fieldMap[key]);
                }
            }
            if (includeCustomObservations) {
                for (var key in customFieldMap) {
                    if (customFieldMap.hasOwnProperty(key)) {
                        allFields = allFields.concat(customFieldMap[key]);
                    }
                }
            }
            return allFields;
        },

        /**
         * Given a field-spec from this file, a value, and a Form object,
         * populate the relevant field in the form, 
         */
        populateField: function(field, val, form) {
            if (!val) { return; }
            if (field.sectionSelector) {
                $(field.sectionSelector, form.getContainer()).show();
            }
            if (field.sectionWrapClass) {
                $(field.sectionTrigger, form.getContainer())
                    .closest(field.sectionWrapClass).remove();
            }
            if (field.sectionTrigger) {
                $(field.sectionTrigger, form.getContainer()).hide();
            }
            form.getInfoField(field.name).setVal(val);
        },

        /**
         * There may be many BP row added
         */
        getBpFields: function(i) {
            return getBpFields(i);
        },

        /**
         * Called to clean input for the VisitNote and Doc Vitals. Technically,
         * Doc Vitals uses only the first one and the note uses only the second,
         * but they're very similar, so they're grouped here.
         */
        getChangeFn: function(name, vitalsProcessor) {
            if (name === 'weight') {
                return function() { return vitalsProcessor.processWeightInput(); };
            }
            if (name === 'height') {
                return function() { return vitalsProcessor.processHeightInput(); };
            }
            if (name === 'hc') {
                return function() { return vitalsProcessor.processHcInput(); };
            }
            if (name === 'pain') {
                return function() { return vitalsProcessor.processPainScaleInput(); };
            }
            return null;
        },
        getCleanInputFn: function(name, vitalsProcessor) {
            if (name === 'weight') {
                return function(val, fieldName) { 
                    if (fieldName === 'weight') {
                        return vitalsProcessor.processWeightInput();
                    }
                    return val;
                };
            }
            if (name === 'height') {
                return function(val, fieldName) { 
                    if (fieldName === 'height') {
                        return vitalsProcessor.processHeightInput(); 
                    }
                    return val;
                };
            }
            if (name === 'hc') {
                return function(val, fieldName) {
                    if (fieldName === 'hc') {
                        return vitalsProcessor.processHcInput();
                    }
                    return val;
                };
            }
            if (name === 'pain') {
                return function(val, fieldName) {
                    if (fieldName === 'pain') {
                        return vitalsProcessor.processPainScaleInput();
                    }
                    return val;
                };
            }
            return null;
        },

        /**
         * Run whenever a new BP row is added or an existing one is deleted -
         * show only the last + button and make sure the X buttons only show
         * if there are > 1 BP rows
         */
        cleanBpTriggers: function($container) {
            if ($('.bp-input', $container).length > 1) {
                $('.remove-bp-trigger', $container).show();
            } else {
                $('.remove-bp-trigger', $container).hide();
            }
            $('.add-bp-trigger', $container).hide()
                .last().show();
        }

    };


    function getBpFields(i) {
        // bpS_ and bD_ use a placeholder instead of infotext, so they
        // can be "number" inputs that auto-delete non-numeric input
        return [{
            name: 'bpS_'+i,
            property: 'bpS',
            selector: ':input[name="bpS_'+i+'"]',
            maxLength: 3
        }, {
            name: 'bpD_'+i,
            property: 'bpD',
            selector: ':input[name="bpD_'+i+'"]',
            maxLength: 4
        }, {
            name: 'bpNote_'+i,
            property: 'extraNote',
            selector: ':input[name="bpNote_'+i+'"]',
            infoText: 'note...',
            maxLength: 150,
            height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
            doShrink: true,
            sectionSelector: '.bp-'+i+'-note-section',
            sectionTrigger: '.vitals-note-show-trigger[data-type="bp-'+i+'"]',
            sectionWrapClass: '.vitals-wrapper'
        }];
    }

})();